export const metaOptions = [
    { key: 'ml', label: 'ml' },
    { key: 'kg', label: 'kg' },
    { key: 'pcs', label: 'pcs' },
    { key: 'ea', label: 'ea' },
    { key: 'set', label: 'set' },
    { key: 'box', label: 'box' },
    { key: 'bag', label: 'bag' },
    { key: 'bundle', label: 'bundle' },
    { key: 'roll', label: 'roll' },
    { key: 'tube', label: 'tube' },
    { key: 'alc', label: 'alc' },
    { key: 'subledger', label: 'subledger' },
    { key: 'promo_duty', label: 'promo_duty' },
];
